'use client';

import { useState } from 'react';
import { installDomMutationGuard } from '../../utils/domMutationGuard';

/**
 * Installs the removeChild/insertBefore guard (see `domMutationGuard.ts`)
 * on the first client render, from the root layout — before React commits
 * any update that could touch a translated node. Same lazy-`useState`
 * once-per-mount pattern as `TelemetryInit`. The guard itself no-ops on the
 * server (no `Node` global) and on repeat calls.
 */
export const DomMutationGuard = () => {
  useState(() => {
    installDomMutationGuard();
    return null;
  });
  return null;
};
